import React, {useState, useEffect} from 'react';

import { Card, Col } from "react-bootstrap";

import Loading from '../Loading';
import ButtonLoadFile from "../ButtonLoadFile";

import defaultImgProfile from '../../assets/img/no-profile-img-294x300.jpg';

const CardImgProfile = ({colSize, accept, load, loadImg, name, img, formatImg, eventUploadFile}) => {

    if(!colSize) {colSize = 3}

    const [imgProfile, setImgProfile] = useState(defaultImgProfile);


    useEffect(() => {        
        const loadImg = () => {
            setImgProfile(img);
        }
        if(img){
            loadImg()
        }
        // eslint-disable-next-line
    }, [img])

    return ( 
        <Col lg={colSize} >
        
            <Card className="shadow mb-4">
                {(load || loadImg)? 
                  <Loading /> : 
                  <>
                    {img ?
                        <Card.Img 
                            variant="top" 
                            src={`data:image/${formatImg};base64,${img}`}
                            
                        />:
                        <Card.Img 
                            variant="top" 
                            src={imgProfile}
                        />
                        }
                    

                    <Card.Body>
                        <Card.Title className="text-center">{name}</Card.Title>
                        <Card.Text className="text-center">
                            <ButtonLoadFile 
                                textButton={"Subir Nueva imagen.."}
                                className={"btn btn-outline-secondary"}  
                                eventUploadFile={eventUploadFile}   
                                accept={accept}                           
                            />
                        </Card.Text>               
                    </Card.Body>
                </>
                }
            </Card>
        </Col>
     );
}
 
export default CardImgProfile;